import { Component, Input } from '@angular/core';

import { IAlert } from './alert.model';

@Component({
  selector: 'app-opin-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class OpinAlertComponent implements IAlert {
  @Input() text: IAlert['text'];
  @Input() button: IAlert['button'];
  @Input() variant: IAlert['variant'];
  @Input() description: IAlert['description'];

  private isVariantSelected(variant: typeof this.variant) {
    return this.variant === variant;
  }

  getContainerClassType(): Record<typeof this.variant, boolean> {
    return {
      info: this.isVariantSelected('info'),
      error: this.isVariantSelected('error'),
      warning: this.isVariantSelected('warning')
    };
  }
}
